// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2UAbm","select":"Header_select__oGas6","clinic":"Header_clinic__1pfAy"};